import React from 'react';
import './ShowroomBanner.css';

export const ShowroomBanner = () => {
    return (
        <div id="showroomBanner">
            <h1>HIAsecure Showroom</h1>
            <p>
                Espace de test et de découverte des solutions d'authentification HIAsecure.
            </p>
            <div className="showroomBannerGradientBorder"></div>
        </div>
    );
}
